import {RootState} from '../../../reducers';

export const getNotifications = (state: RootState) => state.notifications;
